import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  CreateSupportTemplateRequest,
  UpdateSupportTemplateRequest,
  ViewSupportTemplateRequest
} from './support-template.types';

import {
  requestCreateSupportTemplate,
  requestUpdateSupportTemplate,
  requestViewSupportTemplate
} from './support-template.actions';

export const useSupportTemplateApi = () => {
  const dispatch = useDispatch();

  const createSupportTemplate = useCallback(
    (requestData: CreateSupportTemplateRequest, onSuccess?: () => void) => {
      dispatch(requestCreateSupportTemplate({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewSupportTemplate = useCallback(
    (requestData: ViewSupportTemplateRequest, onSuccess?: () => void) => {
      dispatch(requestViewSupportTemplate({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const updateSupportTemplate = useCallback(
    (requestData: UpdateSupportTemplateRequest, onSuccess?: () => void) => {
      dispatch(requestUpdateSupportTemplate({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { createSupportTemplate, viewSupportTemplate, updateSupportTemplate };
};
